import { gql } from '@apollo/client';
import eventBidFragment from './eventBidFragment';
import userEventParticipationInfoCalendarViewFragment from './userEventParticipationInfoCalendarViewFragment';

const CONFIRM_ASSIGNMENT_ACTION = gql`
  mutation ConfirmAssignmentAction($assignmentData: EventAppraiserAssignmentActionInput!) {
    confirmAssignmentAction(assignmentData: $assignmentData) {
      AppraiserEvent {
        Id
        AtmAssignmentPendingConfirmation
        UserAssignmentPendingActions {
          ObservationAssignmentActionRequired
        }
        TargetUserEventParticipationInfo {
          ...UserEventParticipationInfoFields
        }
      }
      AppraiserEventBid {
        CanBidForEvent
        ...EventBidFields
      }
    }
  }

  ${eventBidFragment}
  ${userEventParticipationInfoCalendarViewFragment}
`;

export default CONFIRM_ASSIGNMENT_ACTION;
